import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './components/signin/sign-in.component';
import { SignedOutComponent } from './components/signout/signed-out.component';
import { ParamsGuardService } from './providers/params-guard.service';
import { LoginComponent } from './components/login/login.component';
import { BrowserCompatibilityComponent } from './components/browser-compatibility/browser-compatibility.component';
import { ManualsComponent } from './components/manuals/manuals.component';
import { SecurityInformationComponent } from './components/security-information/security-information.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { LanguageService } from '@ibank-globals/language';
import { LinkBlockedComponent } from './components/link-blocked/link-blocked.component';
import { CommonQuestionsComponent } from './components/common-questions/common-questions.component';
import { SecurityInfoComponent } from './components/security-info/security-info.component';
import { LoginContainerComponent } from './components/login-container/login-container.component';
import { FaqContainerComponent } from './components/faq-container/faq-container.component';

const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'login',
	},
	{
		path: 'login',
		component: LoginContainerComponent,
		canActivate: [ParamsGuardService],
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'linkUser',
		component: LoginContainerComponent,
		canActivate: [ParamsGuardService],
		data: { langResourceName: 'login', linkNewUser: true },
		resolve: { lang: LanguageService },
	},
	{
		path: 'switchUser',
		component: LoginContainerComponent,
		canActivate: [ParamsGuardService],
		data: { langResourceName: 'login', switchUser: true },
		resolve: { lang: LanguageService },
	},
	{
		path: 'renewLink',
		component: LoginContainerComponent,
		canActivate: [ParamsGuardService],
		data: { langResourceName: 'login', renewLink: true },
		resolve: { lang: LanguageService },
	},
	{
		path: 'signedout',
		component: SignedOutComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'browser-compatibility',
		component: BrowserCompatibilityComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'manuals',
		component: ManualsComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	// {
	// 	path: 'security-information',
	// 	component: SecurityInformationComponent,
	// 	data: { langResourceName: 'login' },
	// 	resolve: { lang: LanguageService },
	// },
	{
		path: 'security-information',
		component: SecurityInfoComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'general-information',
		component: GeneralInformationComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'link-blocked',
		component: LinkBlockedComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	// {
	// 	path: 'faqs',
	// 	component: CommonQuestionsComponent,
	// 	data: { langResourceName: 'login' },
	// 	resolve: { lang: LanguageService },
	// },
	{
		path: 'faqs',
		component: FaqContainerComponent,
		data: { langResourceName: 'login' },
		resolve: { lang: LanguageService },
	},
	{
		path: 'impersonation-login',
		component: LoginContainerComponent,
		data: { langResourceName: 'login', isImpersonation: true },
		resolve: { lang: LanguageService },
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		paramsInheritanceStrategy: 'emptyOnly'
	})],
	exports: [RouterModule],
})
export class AppRoutingModule {}

export const routedComponents = [SignInComponent];
